import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { shopButtons } from './ShopButtons.utils';

import * as Styled from './ShopButtons.styled';

/**
 * Three buttons that direct users to women, men, and kids collection pages on click
 */
const ShopButtons = ({ className, hasLargeButtonGap, ...props }) => {
  const router = useRouter();

  const handleButtonClick = (e, path) => {
    e.preventDefault();
    if (path) router.push(path);
  };

  return (
    <Styled.ShopButtons
      className={className}
      hasLargeButtonGap={hasLargeButtonGap}
    >
      {shopButtons.map((button) => (
        <Styled.CTAButton
          {...props}
          as="a"
          href={button.url}
          key={button.url}
          colorMode="night"
          onClick={(e) => handleButtonClick(e, button.url)}
        >
          {button.title}
        </Styled.CTAButton>
      ))}
    </Styled.ShopButtons>
  );
};

ShopButtons.propTypes = {
  className: PropTypes.string,
  hasLargeButtonGap: PropTypes.bool
};

ShopButtons.defaultProps = {
  className: null,
  hasLargeButtonGap: false
};

export default ShopButtons;
